export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";
export const APP_IFRAMED = "APP_IFRAMED";
export const SET_MAX_SCORE = "SET_MAX_SCORE";

export const userLogin = data => ({
  type: USER_LOGIN,
  data
});

export const userLogout = data => ({
  type: USER_LOGOUT,
  data
});

export const setAppIframed = () => ({
  type: APP_IFRAMED
});

export const setMaxScore = () => ({
	type : SET_MAX_SCORE
});


// WEBPACK FOOTER //
// ./src/js/actions/index.js